import React from 'react';

import './Home.css';

import MainLogo from '../img/mainlogo-01.png';

const home = () => {
    // const { loading, error, data } = useQuery(GET_MAIN);

    // const imageDetail = (!!loading || !!error) ? [] : data.main;

    return (
        <div className={"carousel-inner"}>
            <img
                className="d-block img-fluid"
                src={MainLogo}
                style={{maxHeight: 500}}
                alt="Thumbprints Baking Company"
            />
        </div>
    )
};
export default home;